export const en = {
  // Header / Navigation
  nav: {
    home: 'Home',
    products: 'Products',
    labSupplies: 'Lab Supplies',
    research: 'Research',
    about: 'About',
    blog: 'Blog',
    contact: 'Contact',
    signIn: 'Sign In',
    signOut: 'Sign Out',
    community: 'Community',
    myAccount: 'My Account',
    admin: 'Admin',
    myRequests: 'My Requests',
    orderHistory: 'Order History',
    wishlist: 'Wishlist',
  },
  // Research dropdown
  researchDropdown: {
    glp1: 'GLP-1 Research',
    tirzepatide: 'Tirzepatide Research',
    semaglutide: 'Semaglutide Research',
    guide: 'Research Guide',
  },
  // Home page
  home: {
    heroHeading1: 'PRECISION RESEARCH.',
    heroHeading2: 'ELEVATED STANDARDS.',
    heroSubtitle: 'High-purity compounds for advanced scientific research. Third-party tested, batch verified.',
    submitRequest: 'CONTACT US',
    howPayment: 'HOW PAYMENT WORKS',
    trustBadges: 'Research Use Only • Laboratory Supply • Professional Presentation',
    shopNow: 'Shop Now',
    learnMore: 'Learn More',
    featuredProducts: 'Featured Products',
    featuredSubtitle: 'High-purity research peptides for advanced laboratory studies',
    whyChoose: 'Why Choose RCM Biosciences?',
    whyChooseSubtitle: 'Committed to excellence in every aspect of research peptide manufacturing',
    purity: 'Research-Grade Purity',
    purityDesc: 'Purity is documented per compound and lot on each Certificate of Analysis. Results vary by batch and are verified by independent third-party laboratory testing.',
    shipping: 'Fast & Secure Shipping',
    shippingDesc: 'Temperature-controlled packaging with priority shipping options. Multiple USPS methods available — shipping cost confirmed on your invoice.',
    support: 'Expert Support',
    supportDesc: 'Our research team is available to help with product selection and technical questions.',
    viewAll: 'View All Products',
    viewDetails: 'View Details',
    viewProducts: 'View Products',
    from: 'From',
    batchTested: 'Batch-tested · Research-grade purity',
    catNo: 'Cat. No:',
    purityLabel: 'Purity:',
    freeShipping: 'Shipping calculated on invoice',
    researchAreas: 'Research Areas We Supply',
    researchAreasSubtitle: 'Supporting scientific investigation across multiple research disciplines with high-purity compounds',
    metabolicResearch: 'Metabolic Research',
    metabolicCompounds: 'Compounds: Semaglutide, Tirzepatide, Survodutide, Cagrilintide',
    metabolicBullet1: 'GLP-1 and GIP receptor signaling pathway studies',
    metabolicBullet2: 'Incretin hormone mechanism investigations',
    metabolicBullet3: 'Glucose homeostasis and insulin secretion research',
    metabolicBullet4: 'Dual and triple receptor agonist binding assays',
    tissueRepair: 'Tissue Repair & Regeneration',
    tissueCompounds: 'Compounds: BPC-157, TB-500, GHK-Cu',
    tissueBullet1: 'Angiogenesis and neo-vascularization investigations',
    tissueBullet2: 'Tendon, ligament, and connective tissue modeling',
    tissueBullet3: 'Inflammatory cascade mediation studies',
    tissueBullet4: 'Wound healing peptide signaling pathway research',
    cognitiveNeuro: 'Cognitive & Neurological',
    cognitiveCompounds: 'Compounds: Semax, Selank, Pinealon, Epitalon',
    cognitiveBullet1: 'BDNF expression and neuroplasticity research',
    cognitiveBullet2: 'Neuropeptide processing enzyme studies',
    cognitiveBullet3: 'Telomerase activation in cellular senescence research',
    cognitiveBullet4: 'Anxiolytic and stress response modulation assays',
    growthHormone: 'Growth Hormone Research',
    growthCompounds: 'Compounds: CJC-1295, Ipamorelin, GHRP-6, GHRP-2, Tesamorelin, Hexarelin',
    growthBullet1: 'GHRH receptor agonist binding characterization',
    growthBullet2: 'Ghrelin receptor pathway signaling studies',
    growthBullet3: 'Pulsatile GH release pattern analysis',
    growthBullet4: 'Growth factor cascade investigations',
    combinationResearch: 'Combination Research',
    combinationCompounds: 'Compounds: BPC+TB500 Blend, CJC+Ipamorelin Blend, and more',
    combinationBullet1: 'Multi-peptide synergy and potentiation studies',
    combinationBullet2: 'Dose-response relationship characterization',
    combinationBullet3: 'Compound stability in mixed formulations',
    combinationBullet4: 'Combined mechanism pathway analysis',
    labSupplies: 'Laboratory Supplies',
    labCompounds: 'Products: Laboratory Research Diluent, Syringes, Alcohol Pads, Vials, Gloves',
    labBullet1: 'Sterile laboratory research diluent (0.9% benzyl alcohol) for analytical workflows',
    labBullet2: 'Precision insulin syringes for accurate laboratory measurement',
    labBullet3: 'Sterile alcohol prep pads for clean technique',
    labBullet4: 'Complete research supply inventory',
    reviewsTitle: 'What Researchers Say',
    reviewsSubtitle: 'Trusted by researchers across institutions',
    basedOn: 'Based on',
    reviews: 'verified reviews',
    noReviews: 'No reviews yet.',
    communityTitle: 'Research Community',
    communitySubtitle: 'Connect with fellow researchers, share findings, and stay updated on the latest in peptide research.',
    joinCommunity: 'Join Community',
    signInToJoin: 'Sign In to Join',
    joinDiscussion: 'Join the discussion',
    members: 'members',
    newsletterTitle: 'Stay Updated',
    newsletterSubtitle: 'Subscribe to our research newsletter for the latest updates, new product announcements, and exclusive offers.',
    enterEmail: 'Enter your email',
    subscribe: 'Subscribe',
    subscribing: 'Subscribing...',
    subscribeSuccess: 'Welcome! Check your email for confirmation.',
    alreadySubscribed: 'Already subscribed!',
    complianceLine: 'All compounds are supplied strictly for laboratory research purposes. No therapeutic claims are made.',
    seeAllReviews: 'See All Reviews',
    // 2026-02: reconstitution/dose-preparation calculator strings removed
    // (researchTools / researchToolsSubtitle / reconstitutionCalc /
    // reconstitutionDesc / openCalculator / calcDisclaimer). Do not
    // re-add without a product decision.
    communityBadge: 'RESEARCH COMMUNITY',
    welcomeCommunity: 'Welcome to the RCM Community',
    welcomeDesc: "We're glad you're here. This community was created as a place where people can connect, learn, share experiences, and support each other.",
    welcomeDesc2: "Whether you're just getting started or have been on your journey for a while, you're in the right place.",
    firstThings: 'First Things First',
    firstThingsDesc: 'Visit the "Introduce Yourself" section and tell us:',
    yourName: 'Your name',
    whereFrom: "Where you're from",
    whatBrought: 'What brought you to the community',
    loveMeeting: 'We love meeting new members.',
    thingsYouCan: 'Things You Can Do Here',
    insideCommunity: 'Inside the community you can:',
    askQuestions: 'Ask questions',
    shareProgress: 'Share your progress',
    stayMotivated: 'Stay motivated',
    connectOthers: 'Connect with others on the same journey',
    quickReminders: 'A Few Quick Reminders',
    beRespectful: 'Be respectful to everyone',
    noSpam: 'No spam or promotions',
    noMedicalAdvice: 'No medical advice',
    protectPrivacy: 'Protect your privacy',
    readGuidelines: 'Read full Community Guidelines',
    howToJoin: 'How to Join',
    howToJoinDesc: 'Click "Sign In" at the top of the page or the button below, create an account, then click any room to join.',
    signInToChat: 'Sign In to Chat',
    chatComingSoon: 'Chat rooms coming soon. Check back shortly!',
    viewAllRooms: 'View All Community Rooms',
    communityGuidelines: 'Community Guidelines',
    ctaTitle: 'Ready to Elevate Your Research?',
    ctaDesc: 'Contact our team to discuss your research needs and explore our premium research peptides.',
    submitRequest: 'Contact Us',
  },
  // Products page
  products: {
    title: 'Research Peptide Catalog',
    labTitle: 'RCM Lab Supplies',
    subtitle: 'Browse laboratory research peptides, bioscience compounds, research blends, and supplies organized by research category, compound, and vial strength. Product pages include available specifications and batch documentation.',
    labSubtitle: 'RCM Biosciences provides general laboratory and research accessories designed to support structured research environments.',
    searchPlaceholder: 'Search products by name, catalog number, or dosage...',
    showing: 'Showing',
    product: 'product',
    products_plural: 'products',
    allProducts: 'All Products',
    addToCart: 'Add to Cart',
    added: 'Added!',
    viewDetails: 'View Details',
    noProducts: 'No products found matching your criteria.',
    bundles: 'Research Bundles',
    saveMore: 'Save More',
    save: 'SAVE',
    includes: 'Includes:',
    view: 'View',
    youSave: 'You save',
    addBundle: 'Add Bundle to Cart',
    bundleAdded: 'Bundle Added!',
    customSolution: 'Need a Custom Solution?',
    customDesc: 'We offer custom synthesis and bulk ordering options for research institutions. Contact our team to discuss your specific requirements.',
    contactUs: 'Contact Us',
    catNo: 'Cat. No:',
    purity: 'Purity:',
    storage: 'Storage:',
    applications: 'Applications:',
    suitableFor: 'Suitable For:',
    sku: 'SKU:',
    condition: 'Condition:',
    inStock: 'In Stock',
    outOfStock: 'Out of Stock',
    backorder: 'Backorder',
    backorderMsg: 'This item is currently out of stock. You can still order — expect 7 to 10 business days for delivery.',
    from: 'From',
    batchTested: 'Batch-tested',
    researchGrade: 'Research-grade purity',
  },
  // Product Detail
  productDetail: {
    backToProducts: 'Back to Products',
    quantity: 'Quantity',
    addToCart: 'Add to Cart',
    addedToCart: 'Added to Cart!',
    singleVial: 'Single Vial',
    tenPack: '10-Pack',
    description: 'Description',
    specifications: 'Specifications',
    researchData: 'Research Data',
    relatedProducts: 'Related Products',
    forResearchOnly: 'For Research Use Only',
    loading: 'Loading product...',
    notFound: 'Product Not Found',
    notFoundMsg: 'The product you are looking for could not be found.',
    purity: 'Purity',
    storage: 'Storage',
    category: 'Category',
    catNo: 'Cat. No.',
    researchApplications: 'Research Applications',
    inStock: 'In Stock',
    outOfStock: 'Out of Stock',
    availability: 'Availability',
    backorder: 'Backorder',
    backorderTitle: 'Currently Out of Stock',
    backorderMsg: 'This item is currently out of stock. You can still order — expect 7 to 10 business days for delivery.',
    each: 'each',
    viewCart: 'View Cart',
    technicalDescription: 'Technical Research Description',
    simplifiedDescription: 'Simplified Explanation',
    researchProfile: 'Research Profile',
    mechanismOfAction: 'Mechanism of Action',
    primaryResearch: 'Primary Research Areas',
    handlingGuidelines: 'Handling Guidelines',
    reconstitution: 'Peptide Dilution',
    dosageRange: 'Research Dosage Range',
    frequency: 'Frequency',
    stabilityNotes: 'Stability Notes',
    references: 'Academic References',
    disclaimer: 'DISCLAIMER: This product is sold for research purposes only. Not for human consumption.',
    saveToWishlist: 'Save to Wishlist',
    removeFromWishlist: 'Remove from Wishlist',
    signInForWishlist: 'Please sign in to add to wishlist',
    addedToWishlist: 'Added to wishlist',
    removedFromWishlist: 'Removed from wishlist',
    bacteriostaticWater: 'Related Laboratory Supply',
    bacteriostaticDesc: 'Laboratory Research Diluent — 0.9% Benzyl Alcohol is available separately for qualified laboratory workflows. Research use only. Not for human or animal use. Not for injection, diagnostic, clinical, therapeutic, or veterinary use.',
    relatedLabSupplyTitle: 'Related Laboratory Supply',
    relatedLabSupplyText: 'Laboratory Research Diluent — 0.9% Benzyl Alcohol is available separately for qualified laboratory workflows. Research use only. Not for human or animal use. Not for injection, diagnostic, clinical, therapeutic, or veterinary use.',
    // Low-stock urgency label — `{count}` is interpolated by t() at runtime.
    onlyNLeft: 'Only {count} left — order soon',
  },
  // Cart
  cart: {
    title: 'Shopping Cart',
    empty: 'Your cart is empty',
    subtotal: 'Subtotal',
    shipping: 'Shipping',
    total: 'Total',
    checkout: 'Proceed to Checkout',
    signInToCheckout: 'Sign In to Checkout',
    continueShopping: 'Continue Shopping',
    remove: 'Remove',
    freeShipping: 'Quoted',
    freeShippingMsg: 'Shipping is calculated on your invoice.',
    bacteriostaticWater: 'Related Laboratory Supply',
    bacteriostaticDesc: 'Laboratory Research Diluent — 0.9% Benzyl Alcohol is available separately for qualified laboratory workflows. Research use only. Not for human or animal use. Not for injection.',
    shippingMethod: 'Shipping Method',
    ground: 'USPS Ground Advantage',
    groundDays: '2-5 business days',
    priority: 'USPS Priority Mail',
    priorityDays: '1-3 business days',
    express: 'USPS Priority Mail Express',
    expressDays: '1-2 business days',
    pickup: 'Local Pickup',
    pickupDays: 'Same day',
  },
  // Checkout
  checkout: {
    title: 'Checkout',
    subtitle: 'Complete your order and receive payment instructions via email',
    emptyCart: 'Your Cart is Empty',
    emptyCartMsg: 'Add some products to your cart before checking out.',
    browseProducts: 'Browse Products',
    customerInfo: 'Contact Information',
    name: 'Full Name',
    email: 'Email Address',
    phone: 'Phone Number',
    institution: 'Institution/Company',
    shippingAddress: 'Shipping Address',
    billingAddress: 'Billing Address',
    sameAsBilling: 'Same as billing address',
    sameAsShipping: 'Same as shipping address',
    shippingMethod: 'Shipping Method',
    freeShippingMsg: 'Shipping cost will be confirmed on the invoice sent to your email.',
    orderNotes: 'Order Notes (Optional)',
    orderNotesPlaceholder: 'Any special instructions or notes for your order...',
    orderSummary: 'Order Summary',
    qty: 'Qty',
    total: 'Total',
    freeShipping: 'FREE',
    selectPaymentMethodTitle: 'Select Payment Method',
    selectPaymentMethodSubtitle: 'Choose how you would like to pay. PayPal completes immediately; the others let us send you secure payment instructions.',
    selectPaymentMethod: 'Please select a payment method to continue.',
    selectPaymentMethodFirst: 'Select a Payment Method',
    noteLabel: 'Note:',
    cardNotice: 'After you submit, RCM will email a secure card payment link. Your order is not confirmed until payment is completed.',
    zelleNotice: 'After you submit, RCM will send Zelle payment instructions to your email or phone. Your order is not confirmed until payment is completed.',
    achNotice: 'After you submit, RCM will send ACH/bank-transfer instructions to your email or phone. Your order is not confirmed until payment is completed.',
    promoCode: 'Promo Code',
    referralCode: 'Referral Code',
    enterCode: 'Enter code',
    enterReferral: 'Enter referral code (e.g. REF-XXXX)',
    apply: 'Apply',
    checking: 'Checking...',
    remove: 'Remove',
    saving: 'You\'re saving',
    paymentInstructions: 'Payment Instructions',
    paymentDesc: 'After placing your order, you\'ll receive an invoice via email with instructions to pay via:',
    payWithPaypal: 'Pay with PayPal',
    bacWaterNote: 'Laboratory Research Diluent — 0.9% Benzyl Alcohol is available separately for qualified laboratory workflows. Research use only. Not for human or animal use. Not for injection.',
    relatedLabSupplyLabel: 'Related Laboratory Supply:',
    relatedLabSupplyNote: 'Laboratory Research Diluent — 0.9% Benzyl Alcohol is available separately for qualified laboratory workflows. Research use only. Not for human or animal use. Not for injection.',
    labSuppliesConfirm: 'I confirm I am purchasing for lawful purposes and understand this product is not intended for use with any items sold on this website.',
    signatureTitle: 'Digital Signature',
    signatureDesc: 'By signing below, you confirm you are a qualified researcher and agree to the terms of purchase. All products are for research use only.',
    signHere: 'Sign here to proceed',
    clearSignature: 'Clear',
    signatureCaptured: 'Signature captured',
    signatureRequired: 'Signature Required to Place Order',
    placeOrder: 'Place Order',
    placing: 'Processing...',
    researchOnly: 'FOR RESEARCH USE ONLY',
    supportNote: 'Questions about your order?',
    phoneRequired: 'Valid phone number required',
    payPalAmount: 'Amount to enter on PayPal:',
    copyAmount: 'Copy $',
    amountCopied: 'Amount copied — paste it into PayPal',
    placingOrder: 'Placing order…',
    placeOrderAndPaypal: 'Place Order & Pay with PayPal',
    paypalNote: 'Clicking this places your order, then opens PayPal in a new tab to pay.',
    callOrText: 'Call or Text',
    orderPlaced: 'Order Placed!',
    invoiceSent: 'has been sent to your email.',
    nextSteps: 'Next Steps:',
    step1: 'Check your email for the invoice with payment instructions',
    step2: 'Pay via Zelle, Cash App, or Apple Cash',
    step3: 'We\'ll process your order once payment is confirmed',
    step4: 'You\'ll receive tracking info when shipped',
    paymentOptions: 'Payment Options:',
    paymentDetails: 'Zelle, Cash App ($rcmbiosciences), or Apple Cash to (713) 533-2455',
    continueShopping: 'Continue Shopping',
    trackOrder: 'Track Order',
    pickupAddress: 'Pickup Address:',
    pickupDetails: 'RCM Biosciences\nLivingston, TX\nCall (713) 533-2455 to arrange pickup time',
  },
  // Contact
  contact: {
    heroTitle: 'Contact RCM Biosciences',
    heroSubtitle: 'Get in Touch',
    heroDescription: 'Use this page to contact RCM Biosciences about research peptides, product availability, laboratory ordering questions, and general inquiries. Our team is here to help with any questions you may have.',
    contactInfoTitle: 'Contact Information',
    emailLabel: 'Email',
    phoneLabel: 'Phone',
    callOrText: 'Call or Text',
    callOrTextLabel: 'Call or Text',
    hoursLabel: 'Business Hours',
    hoursLine1: 'Monday through Friday',
    hoursLine2: '9:00 AM to 5:00 PM Central Time',
    responseTime: 'Response Time',
    responseTimeDesc: 'Most inquiries receive a response within 24 business hours.',
    name: 'Full Name',
    email: 'Email Address',
    phone: 'Phone Number',
    institution: 'Institution/Organization',
    product: 'Product of Interest',
    selectProduct: 'Select a product',
    customOrder: 'Custom Order',
    message: 'Message',
    messagePlaceholder: 'Please provide details about your research needs, quantity requirements, and any specific questions...',
    submit: 'Send Message',
    submitting: 'Sending...',
    success: 'Message sent! We\'ll get back to you within 24 business hours.',
    error: 'Failed to send message. Please try again or contact us directly.',
    requiredFields: '* Required fields',
    whatToIncludeTitle: 'What to Include in Your Request',
    whatToIncludeDesc: 'To help us process your request faster, please include:',
    includeItem1: 'Full name',
    includeItem2: 'Email address',
    includeItem3: 'Institution or organization',
    includeItem4: 'Product of interest',
    includeItem5: 'Quantity requirements',
    includeItem6: 'Research-related questions',
    includeItem7: 'Any important ordering details',
    requestSupportTitle: 'Research Products and Request Support',
    requestSupportDesc: 'You may use this page to contact us regarding:',
    supportItem1: 'Research peptide availability',
    supportItem2: 'Product questions',
    supportItem3: 'Quantity requests',
    supportItem4: 'Invoice-based ordering',
    supportItem5: 'Laboratory research inquiries',
    supportItem6: 'General support',
    importantNotice: 'Important Research Use Notice',
    noticeDesc: 'All products offered by RCM Biosciences are intended for research use only. They are not intended for human consumption, diagnostic use, therapeutic use, or clinical application. Orders may be reviewed for research-use alignment and request verification before approval.',
    aboutTitle: 'About RCM Biosciences',
    aboutDescription: 'RCM Biosciences is a research peptide and biosciences company serving laboratories and research-focused buyers seeking professional-grade materials, quality-driven service, and reliable support.',
  },
  // About
  about: {
    title: 'About RCM Biosciences',
    subtitle: 'A trusted source for high-purity research peptides and bio sciences.',
    missionTitle: 'Our Mission',
    missionDesc: "We understand that research success depends on the quality and reliability of materials. That's why we've built our reputation on delivering exceptional products that researchers can trust for their most critical experiments.",
    valuesTitle: 'Our Core Values',
    quality: 'Quality First',
    qualityDesc: 'Every product undergoes rigorous testing and quality control to ensure it meets the highest standards for research applications.',
    integrity: 'Scientific Integrity',
    integrityDesc: 'We maintain complete transparency in our manufacturing processes and provide detailed documentation for every batch.',
    customerSupport: 'Customer Support',
    customerSupportDesc: 'Our team of experienced scientists is available to provide technical support and answer questions about our products.',
    partnerTitle: 'Partner With Us',
    partnerDesc: 'Join leading research institutions worldwide who trust RCM Biosciences for their peptide research needs.',
    getStarted: 'Get Started',
  },
  // Blog
  blog: {
    title: 'Research Blog',
    subtitle: 'Scientific insights, research guides, and the latest developments in peptide science.',
    allArticles: 'All Articles',
    readMore: 'Read More',
    noArticles: 'No articles published yet.',
    noCategory: 'No articles in this category.',
    checkBack: 'Check back soon for new research content.',
    backToBlog: 'Back to Blog',
    exploreProducts: 'Explore Our Research Peptides',
    exploreDesc: 'Browse laboratory research compounds with batch-specific Certificate of Analysis information.',
    viewProducts: 'View Products',
  },
  // Auth
  auth: {
    signIn: 'Sign In',
    signUp: 'Create Account',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    name: 'Full Name',
    forgotPassword: 'Forgot Password?',
    noAccount: 'Don\'t have an account?',
    hasAccount: 'Already have an account?',
  },
  // Footer
  footer: {
    description: 'Premium research peptides for laboratories and research institutions. Results driven by quality.',
    quickLinks: 'Quick Links',
    legal: 'Legal',
    disclaimer: 'Research Use Disclaimer',
    terms: 'Terms of Service',
    privacy: 'Privacy Policy',
    researchOnly: 'FOR RESEARCH USE ONLY. NOT FOR HUMAN CONSUMPTION.',
    allRights: 'All rights reserved.',
  },
  // Common
  common: {
    loading: 'Loading...',
    error: 'An error occurred',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
    add: 'Add',
    remove: 'Remove',
    search: 'Search',
    filter: 'Filter',
    sort: 'Sort',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
  },
  // Age verification
  ageVerification: {
    title: 'Age Verification Required',
    message: 'You must be 18 years or older to access this website. This site contains products intended for research use only.',
    confirm: 'I Confirm & Enter',
    deny: 'I Am Under 18',
  },
  // Blog categories
  blogCategories: {
    research: 'Research',
    news: 'News',
    guides: 'Guides',
    industry: 'Industry',
    science: 'Science',
    education: 'Education',
    comparison: 'Comparison',
    guide: 'Guide',
  },
  // Blog Article page
  blogArticle: {
    notFound: 'Article Not Found',
    notFoundDesc: 'The article you\'re looking for doesn\'t exist or has been removed.',
    backToBlog: 'Back to Blog',
    exploreTitle: 'Explore Our Research Peptides',
    exploreDesc: 'Browse laboratory research compounds with batch-specific Certificate of Analysis information.',
    viewProducts: 'View Products',
  },
  // Shared research page strings
  research: {
    disclaimer: 'FOR RESEARCH PURPOSES ONLY — NOT FOR HUMAN CONSUMPTION',
    notForHuman: 'NOT FOR HUMAN CONSUMPTION. NOT FOR MEDICAL OR CLINICAL USE.',
    notForHumanShort: 'NOT FOR HUMAN CONSUMPTION.',
    researchApps: 'Research Applications',
    whyRcm: 'Why Choose RCM Biosciences',
    whyRcmShort: 'Why Choose RCM',
    standard: 'The Standard Behind the Research.',
    faq: 'Frequently Asked Questions',
    exploreMore: 'Explore More',
    exploreRelated: 'Explore Related Research',
    learnMore: 'Learn More',
    productSpecs: 'Product Specifications',
    footerDisclaimer: 'RCM Biosciences supplies research-grade compounds intended for laboratory and analytical research use only.',
    footerDisclaimerShort: 'RCM Biosciences supplies research-grade compounds for laboratory use only.',
    allResearchNote: 'All compounds are intended strictly for laboratory and analytical research use.',
    premiumSourcing: 'Premium sourcing standards',
    consistentQuality: 'Consistent batch quality',
    professionalPkg: 'Professional packaging',
    researchSupply: 'Research-focused supply chain',
    consistentGrade: 'Consistent research-grade quality',
    professionalStd: 'Professional packaging standards',
    reliableSource: 'Reliable sourcing and supply',
    premiumResearch: 'Premium research sourcing',
    consistentQualityShort: 'Consistent quality',
    labSupply: 'Laboratory-focused supply',
    rcmDesc: 'RCM Biosciences provides high-quality research-grade compounds designed for laboratory consistency and analytical reliability.',
    compound: 'Compound',
    category: 'Category',
    format: 'Format',
    purity: 'Purity',
    storage: 'Storage',
    lyophilized: 'Dry powder',
    highPurity: 'High purity (research grade)',
    controlledStorage: 'Controlled laboratory environment recommended',
  },
  // GLP-1 Research page
  glp1: {
    breadcrumb: 'GLP-1 Research Peptides | Laboratory Study Compounds | RCM Biosciences',
    title: 'GLP-1 Research Peptides',
    subtitle: 'Advanced compounds studied for their interaction with glucagon-like peptide-1 receptor pathways in controlled laboratory environments.',
    whatAreTitle: 'What are GLP-1 Research Peptides?',
    whatAreP1: 'GLP-1 (glucagon-like peptide-1) receptor agonists are compounds studied for their role in metabolic signaling, receptor activation, and biological pathway analysis.',
    whatAreP2: 'These compounds are widely utilized in laboratory environments to investigate receptor binding, signaling cascades, and metabolic interactions.',
    app1: 'GLP-1 receptor pathway analysis',
    app2: 'Metabolic signaling studies',
    app3: 'Hormonal pathway research',
    app4: 'Laboratory-based compound interaction studies',
    compoundsTitle: 'Key Compounds in GLP-1 Research',
    tirzepatideDesc: 'GLP-1 / GIP dual pathway research',
    semaglutideDesc: 'GLP-1 receptor pathway studies',
    // 2026-02: retatrutideDesc removed alongside Retatrutide hide site-wide.
    faq1q: 'Are GLP-1 peptides intended for human use?',
    faq1a: 'No. These compounds are strictly for research purposes only.',
    faq2q: 'What type of studies use GLP-1 peptides?',
    faq2a: 'Laboratory-based receptor and metabolic pathway research.',
    faq3q: 'Are these pharmaceutical products?',
    faq3a: 'No. These are research-grade compounds only.',
    relatedTirz: 'Tirzepatide Research',
    relatedSema: 'Semaglutide Research',
    // 2026-02: relatedCalc removed (public calculator taken down).
  },
  // Tirzepatide Research page
  tirz: {
    breadcrumb: 'Tirzepatide Research Peptide | GLP-1/GIP Study Compound | RCM Biosciences',
    title: 'Tirzepatide Research Peptide',
    subtitle: 'Dual-pathway research compound studied for GLP-1 and GIP receptor interaction.',
    overview: 'Overview',
    overviewP1: 'Tirzepatide is a dual agonist compound used in laboratory research to evaluate interactions across GLP-1 and GIP receptor pathways.',
    overviewP2: 'It is commonly studied in controlled environments to analyze signaling behavior and receptor response.',
    app1: 'GLP-1 receptor studies',
    app2: 'GIP receptor interaction analysis',
    app3: 'Metabolic pathway research',
    app4: 'Laboratory signaling investigations',
    categoryValue: 'GLP-1 / GIP Research Peptide',
    faq1q: 'Is tirzepatide for human consumption?',
    faq1a: 'No. Research use only.',
    faq2q: 'What is it used for?',
    faq2a: 'Laboratory receptor and metabolic pathway studies.',
    relatedGlp1: 'GLP-1 Research Overview',
    relatedSema: 'Semaglutide Research',
  },
  // Semaglutide Research page
  sema: {
    breadcrumb: 'Semaglutide Research Peptide | GLP-1 Study Compound | RCM Biosciences',
    title: 'Semaglutide Research Peptide',
    subtitle: 'GLP-1 receptor research compound used in controlled laboratory studies.',
    overview: 'Overview',
    overviewP1: 'Semaglutide is a GLP-1 receptor agonist studied in laboratory settings for its interaction with metabolic and signaling pathways.',
    overviewP2: 'It is commonly used in controlled research environments to analyze receptor activation and biological responses.',
    app1: 'GLP-1 receptor analysis',
    app2: 'Metabolic signaling research',
    app3: 'Hormonal pathway studies',
    categoryValue: 'GLP-1 Research Peptide',
    faq1q: 'Is this for human use?',
    faq1a: 'No. Research use only.',
    faq2q: 'What is it studied for?',
    faq2a: 'GLP-1 receptor and metabolic pathway research.',
    relatedTirz: 'Tirzepatide Research',
    relatedGlp1: 'GLP-1 Research Overview',
  },
  // Peptide Calculator page
  calc: {
    breadcrumb: 'Peptide Dilution Calculator | Research Tool | RCM Biosciences',
    title: 'Peptide Dilution Calculator',
    subtitle: 'Laboratory tool designed to assist with peptide dilution calculations in research settings.',
    whatTitle: 'What This Tool Does',
    whatP1: 'This calculator helps determine concentration ratios when combining compounds with laboratory diluents in research environments.',
    whatP2: 'It supports accurate measurement planning for analytical research purposes.',
    calculator: 'Calculator',
    compoundAmount: 'Compound Amount (mg)',
    liquidVolume: 'Liquid Volume (mL)',
    concentration: 'Concentration',
    mcgPerUnit: 'mcg per unit (100 units/mL syringe)',
    howTitle: 'How It Works',
    step1: 'Enter compound amount',
    step2: 'Enter liquid volume',
    step3: 'View calculated concentration',
    precision: 'Designed for clarity and laboratory precision.',
    whyTitle: 'Why Use This Tool',
    why1: 'Reduces calculation errors',
    why2: 'Saves time in lab setup',
    why3: 'Improves consistency',
    noticeTitle: 'Important Notice',
    noticeDesc: 'This tool is intended strictly for laboratory and research use. It does not provide medical, clinical, or human-use guidance.',
    footerNote: 'RCM Biosciences provides research tools and compounds for laboratory use only.',
  },
  // Research Peptide Guide page
  guide: {
    breadcrumb: 'Research Peptide Guide | Laboratory Use Overview | RCM Biosciences',
    title: 'Research Peptide Guide',
    subtitle: 'An overview of research peptides used in laboratory and analytical environments.',
    whatTitle: 'What Are Research Peptides?',
    whatP1: 'Research peptides are compounds utilized in controlled environments to study biological interactions, receptor activity, and molecular signaling.',
    whatP2: 'They are designed for laboratory investigation only.',
    categoriesTitle: 'Common Research Categories',
    cat1: 'GLP-1 receptor compounds',
    cat2: 'Growth-related peptides',
    cat3: 'Regenerative pathway studies',
    cat4: 'Metabolic research compounds',
    bestPracticesTitle: 'Best Practices in Research',
    bp1: 'Maintain controlled storage conditions',
    bp2: 'Follow laboratory handling protocols',
    bp3: 'Ensure accurate measurement and documentation',
    qualityTitle: 'Why Quality Matters',
    qualityDesc: 'Consistency and purity are critical in research environments to ensure reproducibility and reliable outcomes.',
    whyRcmTitle: 'Why RCM Biosciences',
    wrc1: 'High-quality research compounds',
    wrc2: 'Professional packaging',
    wrc3: 'Reliable supply chain',
    faq1q: 'Are research peptides safe for human use?',
    faq1a: 'No. They are strictly for laboratory research.',
    faq2q: 'Who uses research peptides?',
    faq2a: 'Laboratories and analytical research environments.',
    footerNote: 'RCM Biosciences supplies research-grade compounds intended for laboratory use only.',
  },
  // Chat Room
  chat: {
    protected: 'Chat Protected',
    returnToView: 'Return to this tab to view messages',
    loading: 'Loading...',
    members: 'Members',
    invite: 'Invite',
    leave: 'Leave',
    kicked: 'You have been kicked from this room',
    fileTooLarge: 'File too large. Maximum size is 50MB.',
    uploadFailed: 'Failed to upload file',
    deleteConfirm: 'Delete this message?',
    messageDeleted: 'Message deleted',
    deleteFailed: 'Failed to delete message',
    leaveConfirm: 'Are you sure you want to leave this room?',
    isTyping: 'is typing...',
    areTyping: 'are typing...',
    typeMessage: 'Type a message...',
    addCaption: 'Add a caption...',
    send: 'Send',
    reply: 'Reply',
    replyingTo: 'Replying to',
    attachment: 'Attachment',
    downloadFile: 'Download file',
    sharedFile: 'Shared a file:',
    deleteMessage: 'Delete message',
    inviteMembers: 'Invite Members',
    inviteLink: 'Invite Link',
    inviteEmail: 'Email',
    inviteUsername: 'Username',
    inviteBulk: 'Bulk',
    generateLink: 'Generate Invite Link',
    generating: 'Generating...',
    linkGenerated: 'Invite link generated!',
    linkFailed: 'Failed to generate link',
    copyLink: 'Copy',
    copied: 'Copied!',
    linkCopied: 'Link copied to clipboard!',
    shareLink: 'Share this link to invite others:',
    emailAddress: 'Email address',
    emailPlaceholder: 'friend@example.com',
    personalMessage: 'Personal message (optional)',
    personalMessagePlaceholder: 'Hey! Join our research discussion group...',
    sendInvitation: 'Send Invitation',
    sending: 'Sending...',
    inviteSent: 'Invitation sent to',
    inviteFailed: 'Failed to send invitation',
    searchUsers: 'Search by name...',
    noUsersFound: 'No users found',
    add: 'Add',
    adding: '...',
    userAdded: 'has been added to the room',
    inviteUserFailed: 'Failed to invite user',
    bulkDesc: 'Enter email addresses (one per line)',
    bulkPlaceholder: 'email1@example.com\nemail2@example.com\nemail3@example.com',
    sendAll: 'Send All Invitations',
    noValidEmails: 'No valid emails found',
    bulkFailed: 'Failed to send invitations',
    admin: 'Admin',
    makeAdmin: 'Make Admin',
    muteUser: 'Mute',
    unmuteUser: 'Unmute',
    kickUser: 'Kick',
    memberCount: 'members',
    onlineCount: 'online',
    creator: 'Creator',
    muted: 'Muted',
    you: 'You',
    today: 'Today',
    yesterday: 'Yesterday',
    settings: 'Settings',
    manageMembers: 'Manage Members',
  },
  // Auth Modal
  auth: {
    welcomeBack: 'Welcome Back',
    createAccount: 'Create Account',
    signInDesc: 'Sign in to access your saved cart',
    signUpDesc: 'Save your cart and track orders',
    fullName: 'Full Name',
    emailAddress: 'Email Address',
    password: 'Password',
    signInBtn: 'Sign In',
    createAccountBtn: 'Create Account',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?',
    signUpLink: 'Sign up',
    signInLink: 'Sign in',
  },
  // Order History
  orderHistory: {
    title: 'Order History',
    subtitle: 'View your past orders and quickly reorder your favorite products',
    loading: 'Loading your orders...',
    noOrders: 'No Orders Yet',
    noOrdersDesc: "You haven't placed any orders yet. Start shopping to see your order history here.",
    browseProducts: 'Browse Products',
    orderedOn: 'Ordered on',
    items: 'Items:',
    moreItems: 'more items',
    reorder: 'Reorder',
    reordering: 'Reordering...',
    trackUSPS: 'Track Package on USPS',
    trackOnUSPS: 'Track on USPS',
    uspsTracking: 'USPS Tracking',
  },
  // My Requests
  myRequests: {
    title: 'My Requests',
    subtitle: 'View and manage your submitted research requests',
    back: 'Back',
    noRequests: 'No Requests Yet',
    noRequestsDesc: "You haven't submitted any research requests yet.",
    browseProducts: 'Browse Products',
    submitted: 'Submitted',
    requestNum: 'Request',
    editItems: 'Edit Items:',
    saveChanges: 'Save Changes',
    saving: 'Saving...',
    cancel: 'Cancel',
    shippingMethod: 'Shipping Method',
    editRequest: 'Edit Request',
    cancelRequest: 'Cancel Request',
    invoiceNotice: 'An invoice has been created for this request. Check your email for payment details.',
    confirmCancel: 'Are you sure you want to cancel this request?',
  },
  // Referral Program
  referral: {
    badge: 'RCM Biosciences Referral Program',
    heroTitle: 'Share the Science. Earn {referralCredit}.',
    heroDesc: "Know someone in the research community? Refer them to RCM Biosciences and you both get rewarded. It's our way of saying thanks for spreading the word about quality research peptides.",
    getCode: 'Get Your Referral Code',
    howTitle: 'How It Works',
    howSubtitle: 'Three simple steps to start earning rewards',
    step1Title: 'Get Your Code',
    step1Desc: 'Contact us or check your account to receive your unique referral code. Each code is tied to your account for tracking.',
    step2Title: 'Share It',
    step2Desc: 'Send your code to colleagues, lab partners, or anyone in the research community who could benefit from premium peptides.',
    step3Title: 'Earn {referralCredit} Credit',
    step3Desc: "When your referral places their first order using your code, you receive a {referralCredit} credit toward your next purchase. It's that simple.",
    whatYouGet: 'What You Get',
    forYou: 'For You (The Referrer)',
    forYouDesc: '{referralCredit} credit applied to your account after your referral places their first order. Use it on any product in our catalog.',
    forFriend: 'For Your Friend',
    forFriendDesc: 'Your friend gets a {referralCredit} discount on their first order when they use your referral code at checkout. A great introduction to RCM Biosciences.',
    rulesTitle: 'Program Rules',
    rule1: 'Referral codes are issued by RCM Biosciences and are unique to each participant.',
    rule2: 'The referred customer must be a new customer placing their first order with RCM Biosciences.',
    rule3: "The {referralCredit} referral credit is applied after the referred customer's first order is confirmed and paid.",
    rule4: 'Referral credits cannot be combined with other promotional offers or discount codes.',
    rule5: 'Credits are non-transferable and have no cash value.',
    rule6: 'RCM Biosciences reserves the right to modify or discontinue the referral program at any time.',
    rule7: 'Abuse of the referral system (e.g., self-referrals, fake accounts) will result in disqualification.',
    rule8: 'There is no limit to the number of people you can refer.',
    faqTitle: 'Frequently Asked Questions',
    faq1q: 'How do I get my referral code?',
    faq1a: "Contact us through our Contact page or email us at research@rcmbiosciences.com. We'll generate a unique code tied to your account.",
    faq2q: 'When do I receive my {referralCredit} credit?',
    faq2a: "Your credit is applied after your referred friend places and pays for their first order. You'll be notified when it's available.",
    faq3q: 'Is there a limit to how many people I can refer?',
    faq3a: "No! There's no cap. Refer as many people as you like and earn {referralCredit} for each successful referral.",
    faq4q: 'Can my friend use other discounts along with the referral code?',
    faq4a: 'Referral codes cannot be combined with other promotional offers. The {referralCredit} discount will be applied on its own.',
    faq5q: 'Do referral credits expire?',
    faq5a: 'Credits remain on your account until used. However, RCM Biosciences reserves the right to modify the program terms.',
    faq6q: 'Can I refer myself with a different email?',
    faq6a: 'No. Self-referrals are not allowed and will result in disqualification from the program.',
    ctaTitle: 'Ready to Start Earning?',
    ctaDesc: 'Get your referral code today and start sharing premium research peptides with your network.',
    ctaContact: 'Contact Us for Your Code',
    ctaBrowse: 'Browse Products',
  },
  // Admin Dashboard
  admin: {
    sendNote: 'Send Note',
    quickNoteLabel: 'Send a quick note to',
    lastNoteSent: 'Last note sent',
    quickNotePh: 'e.g. Friendly reminder: payment due Friday. Let us know if you have questions.',
    notePlaceholder: 'Enter a note to send',
    noteSent: 'Note sent to customer',
    title: 'Admin Dashboard',
    subtitle: 'Manage quotes and invoices',
    login: 'Admin Login',
    loginDesc: 'Enter password to access admin dashboard',
    loginPlaceholder: 'Enter admin password',
    loginBtn: 'Login',
    logout: 'Logout',
    // Tabs
    tabQuotes: 'Quote Requests',
    tabInvoices: 'Invoices',
    tabSignatures: 'Signatures',
    tabProducts: 'Products',
    tabOrders: 'Orders',
    tabAnalytics: 'Analytics',
    tabEmails: 'Email List',
    tabPromos: 'Promos',
    tabMarketing: 'Marketing',
    tabUsers: 'Users',
    tabChatAdmin: 'Chat Admin',
    tabReferrals: 'Referrals',
    tabPartners: 'Partners',
    tabBlog: 'Blog',
    tabStacks: 'Stacks',
    tabFeatured: 'Featured',
    tabSettings: 'Settings',
    // Common
    actions: 'Actions',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    update: 'Update',
    search: 'Search',
    status: 'Status',
    date: 'Date',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    customer: 'Customer',
    total: 'Total',
    loading: 'Loading...',
    noResults: 'No Results Found',
    showing: 'Showing',
    of: 'of',
    previous: 'Previous',
    next: 'Next',
    page: 'Page',
    all: 'All',
    active: 'Active',
    inactive: 'Inactive',
    // Quotes
    quotePending: 'Pending',
    quoteContacted: 'Contacted',
    quoteCompleted: 'Completed',
    createInvoice: 'Create Invoice',
    invoiceItems: 'Invoice Items',
    message: 'Message',
    institution: 'Institution',
    notProvided: 'Not provided',
    paymentMethod: 'Payment Method',
    // Invoices
    totalInvoices: 'Total Invoices',
    paid: 'Paid',
    unpaid: 'Unpaid',
    cancelled: 'Cancelled',
    sendInvoiceEmail: 'Send Invoice Email',
    sendReminder: 'Send Reminder',
    createOrder: 'Create Order',
    syncOrders: 'Sync Orders',
    orderItems: 'Order Items',
    shippingAddress: 'Shipping Address',
    // Orders
    totalOrders: 'Total Orders',
    pending: 'Pending',
    processing: 'Processing',
    shipped: 'Shipped',
    delivered: 'Delivered',
    updateStatus: 'Update Order Status',
    trackingNumber: 'Tracking Number',
    adminDiscount: 'Admin Discount',
    noDiscount: 'No Discount',
    items: 'Items',
    // Products
    addProduct: 'Add Product',
    allCategories: 'All Categories',
    catNo: 'Cat No.',
    category: 'Category',
    dosage: 'Dosage',
    price: 'Price',
    stock: 'Stock',
    image: 'Image',
    description: 'Description',
    purity: 'Purity',
    storage: 'Storage',
    unlimitedStock: 'Unlimited Stock',
    outOfStock: 'Out of Stock',
    inStock: 'In Stock',
    metabolic: 'Metabolic',
    regenerative: 'Regenerative',
    cognitive: 'Cognitive',
    growth: 'Growth',
    combination: 'Combination',
    labSupplies: 'Lab Supplies',
    other: 'Other',
    // Analytics
    loadingAnalytics: 'Loading analytics...',
    noData: 'No data yet',
    conversionFunnel: 'Conversion Funnel',
    orderStatus: 'Order Status',
    productViews: 'Product Views',
    topPages: 'Top Pages',
    topLocations: 'Top Locations',
    topProducts: 'Top Products by Revenue',
    referralSources: 'Referral Sources',
    // Emails
    emailList: 'Email List',
    addEmail: 'Add Email',
    bulkAdd: 'Bulk Add Emails',
    dateAdded: 'Date Added',
    source: 'Source',
    noEmails: 'No emails collected yet',
    // Promos
    promoCodes: 'Promo Codes',
    createPromo: 'Create Promo Code',
    code: 'Code',
    discountType: 'Discount Type',
    discountValue: 'Discount Value',
    noPromos: 'No promo codes yet',
    promoEmails: 'Promo Email Blasts',
    scheduleEmail: 'Schedule Promo Email',
    sendImmediately: 'Send Immediately',
    scheduleLater: 'Schedule for Later',
    // Marketing
    marketing: 'Marketing & Engagement',
    abandonedCarts: 'No abandoned carts',
    stockAlerts: 'No pending stock alerts',
    noReferralsYet: 'No referrals yet',
    // Users
    userManagement: 'User Management',
    role: 'Role',
    lang: 'Lang',
    orders: 'Orders',
    quotes: 'Quotes',
    deactivate: 'Deactivate',
    reactivate: 'Reactivate',
    deletePermanently: 'Delete Permanently',
    noUsers: 'No registered users yet',
    dataProtection: 'Data Protection Notice',
    typeDelete: 'Type DELETE to confirm:',
    // Chat Admin
    chatAdmin: 'Chat Administration',
    chatRooms: 'Chat Rooms',
    createRoom: 'Create Chat Room',
    bannedUsers: 'Banned Users',
    banUser: 'Ban User from Chat',
    // Blog
    blogManagement: 'Blog Management',
    author: 'Author',
    language: 'Language',
    english: 'English',
    spanish: 'Spanish',
    publishNow: 'Publish immediately',
    noArticles: 'No articles yet',
    // Stacks
    researchStacks: 'Research Stacks',
    stacksConfigured: 'stacks configured',
    newStack: 'New Stack',
    editStack: 'Edit Stack',
    stackName: 'Stack Name',
    icon: 'Icon',
    order: 'Order',
    useCase: 'Use Case',
    productsInStack: 'Products in Stack',
    activeVisible: 'Active (visible on homepage)',
    createStack: 'Create Stack',
    updateStack: 'Update Stack',
    noStacks: 'No Research Stacks',
    noStacksDesc: 'Create your first curated research stack.',
    hidden: 'Hidden',
    products: 'products',
    // Featured
    featuredProducts: 'Featured Products',
    currentlyFeatured: 'Currently Featured:',
    // Settings
    siteSettings: 'Site Settings',
    paypalLink: 'PayPal Payment Link',
    emailAlerts: 'Returning Visitor Email Alerts',
    // Orders / Invoices / Quotes
    orderManagement: 'Order Management',
    invoiceManagement: 'Invoice Management',
    quoteManagement: 'Quote Management',
    invoiceStatus: 'Invoice Status',
    orderNumber: 'Order #',
    invoiceNumber: 'Invoice #',
    customerEmail: 'Customer Email',
    customerName: 'Customer Name',
    paymentStatus: 'Payment Status',
    subtotal: 'Subtotal',
    shipping: 'Shipping',
    discount: 'Discount',
    refunded: 'Refunded',
    viewDetails: 'View Details',
    downloadInvoice: 'Download Invoice',
    markAsPaid: 'Mark as Paid',
    sendEmail: 'Send Email',
    notes: 'Notes',
    tracking: 'Tracking',
    trackingNumber: 'Tracking Number',
    export: 'Export',
    exportCsv: 'Export CSV',
    totalRevenue: 'Total Revenue',
    orderCount: 'Total Orders',
    items: 'Items',
    quantity: 'Quantity',
    price: 'Price',
    addProduct: 'Add Product',
    bulkUpload: 'Bulk Upload',
    refreshTracking: 'Refresh USPS',
    printPickupLabel: 'Print Pickup Label',
    prepareShipping: 'Prepare Shipping Label',
    duplicate: 'Duplicate',
    deleted: 'Deleted',
    saving: 'Saving...',
    sent: 'Sent',
    sending: 'Sending...',
    confirmDelete: 'Delete this item?',
    requiresVerification: 'Email Verified',
    yes: 'Yes',
    no: 'No',
    statusPending: 'Pending',
    statusProcessing: 'Processing',
    statusShipped: 'Shipped',
    statusDelivered: 'Delivered',
    statusCancelled: 'Cancelled',
    statusPaid: 'Paid',
    statusUnpaid: 'Unpaid',
    statusAll: 'All',
    statusOpen: 'Open',
    statusClosed: 'Closed',
    // Orders Tab extras
    noOrdersYet: 'No Orders Yet',
    noOrdersDesc: 'Create orders from paid invoices to see them here.',
    noResultsDesc: 'Try adjusting your search or filter.',
    searchOrdersPh: 'Search by order #, customer, tracking...',
    shipTo: 'Ship To:',
    invoiceLabel: 'Invoice:',
    liveUspsStatus: 'Live USPS Status:',
    expected: 'Expected:',
    checked: 'Checked:',
    itemsLabel: 'Items:',
    prepareShippingLabel: 'Prepare Shipping Label',
    refreshUsps: 'Refresh USPS',
    checking: 'Checking…',
    viewInvoice: 'View Invoice',
    requestReview: 'Request Review',
    reviewRequested: 'Review Requested',
    cnsTitle: 'Prepare Shipping Label',
    cns3Step: '3-step flow:',
    cnsStep1: 'Click Copy Address below',
    cnsStep2: 'Click Open Pirate Ship → paste the address into the "To" field, pick service, pay (commercial rates ~30–50% off USPS retail)',
    cnsStep3: 'Copy the tracking number USPS gives you → come back here → click "Update Status" → paste tracking → set Shipped',
    copyAddressBtn: 'Copy Address',
    openCnsBtn: 'Open Pirate Ship',
    haveTracking: 'I have my tracking number → Update Status now',
    addressCopied: 'Address copied to clipboard!',
    copyFailed: 'Copy failed — please select and copy manually',
    updateOrderStatusTitle: 'Update Order Status',
    trackingRequired: 'USPS Tracking Number (Required for shipped orders)',
    trackingOptional: 'USPS Tracking Number (optional)',
    previewTrack: 'Preview: Track {num} on USPS.com',
    noDiscountOpt: 'No Discount',
    percentageOpt: 'Percentage (%)',
    fixedOpt: 'Fixed Amount ($)',
    valuePh: 'Value',
    discountOff: '% off order',
    currentDiscount: 'Current discount: applied',
    updateOrderBtn: 'Update Order',
    // Invoices Tab extras
    noInvoicesYet: 'No Invoices Yet',
    noInvoicesDesc: 'Create invoices from quote requests to see them here.',
    searchInvoicesPh: 'Search by invoice #, customer name...',
    allStatus: 'All Status',
    createInvoiceBtn: 'Create Invoice',
    createInvoiceTitle: 'Create Invoice',
    fullName: 'Full name',
    customerEmailPh: 'customer@email.com',
    phonePh: '555-000-0000',
    institutionPh: 'Lab/University',
    shippingAddressLabel: 'Shipping Address',
    shippingAddressPh: 'Full shipping address',
    invoiceItemsLabel: 'Invoice Items',
    productDosagePh: 'Product name & dosage',
    qtyPh: 'Qty',
    pricePh: 'Price',
    addItem: '+ Add Item',
    shippingMethodLabel: 'Shipping Method',
    uspsGround: 'USPS Ground — $15',
    priorityMail: 'Priority Mail — $25',
    express: 'Express — $53.34',
    localPickup: 'Local Pickup — Free',
    paymentMethodLabel: 'Payment Method',
    allPayOpts: 'All Payment Options',
    chaseQuickpay: 'Chase QuickPay',
    zelle: 'Zelle',
    cashapp: 'CashApp',
    notesLabel: 'Notes',
    notesPh: 'Optional notes...',
    subtotalLabel: 'Subtotal',
    shippingLabel: 'Shipping',
    free: 'FREE',
    totalLabel: 'Total',
    creating: 'Creating...',
    createSendInvoice: 'Create & Send Invoice',
    signedBy: 'Signed by:',
    signed: 'Signed',
    notSigned: 'Not Signed',
    due: 'Due:',
    downloadPdf: 'Download PDF',
    emailToCustomer: 'Email to Customer',
    markPaidBtn: 'Mark Paid',
    sendInvoiceTitle: 'Send Invoice Email',
    invoiceField: 'Invoice:',
    customerField: 'Customer:',
    amountField: 'Amount:',
    chaseAppOpt: 'Chase App',
    cashAppOpt: 'Cash App',
    appleCashOpt: 'Apple Cash',
    allOptsOpt: 'All Options',
    sendInvoiceBtn: 'Send Invoice',
    // Quotes Tab extras
    totalRequests: 'Total Requests',
    pendingStatus: 'Pending',
    contactedStatus: 'Contacted',
    completedStatus: 'Completed',
    searchQuotesPh: 'Search by name, email, institution...',
    noQuotesYet: 'No Quote Requests Yet',
    noQuotesDesc: 'Quote requests will appear here when customers submit them.',
    productInterest: 'Product Interest',
    notSpecified: 'Not specified',
    messageLabel: 'Message',
    idLabel: 'ID:',
    invoiceCreatedBadge: 'Invoice Created',
    markPending: 'Mark Pending',
    markContacted: 'Mark Contacted',
    markCompleted: 'Mark Completed',
    invoiceItemsTitle: 'Invoice Items',
    productLabel: 'Product',
    selectProduct: '-- Select Product --',
    qtyLabel: 'Qty',
    priceUsdLabel: 'Price ($)',
    totalCol: 'Total',
    shippingUspsLabel: 'Shipping Method (USPS)',
    uspsGroundLong: 'USPS Ground Advantage',
    priorityMailLong: 'USPS Priority Mail',
    priorityExpress: 'USPS Priority Mail Express',
    localPickupShort: 'Local Pickup',
    days25: '2-5 business days',
    days13: '1-3 business days',
    days12: '1-2 business days',
    sameDay: 'Same day',
    requireSig: 'Require signature on delivery',
    sigNote: 'Recommended for chargeback protection',
    notesOptional: 'Notes (optional)',
    notesQuotesPh: 'Payment terms, special instructions, etc.',
    paymentOptions: 'Payment Options',
    quickpayZelle: 'QuickPay with Zelle',
    zelleDirect: 'Zelle Direct',
    anyBankApp: 'Any bank app',
    chaseAndZelle: 'Chase & Zelle',
    bothOptions: 'Both options',
    allPaymentMethods: 'All payment methods',
    zelleEmail: 'Zelle Email/Phone',
    cashTag: 'Cash App $Cashtag',
    applePhone: 'Apple Cash Phone Number',
    chaseLink: 'Chase Payment Link',
    optional: '(optional)',
    zelleHint: 'Enter the Zelle-registered email or phone number',
    cashAppHint: 'Enter your Cash App $Cashtag',
    appleHint: 'Enter your Apple Cash phone number',
    chaseHint: 'Enter your Chase QuickPay link',
    createOrderTitle: 'Create Order',
    orderItemsLabel: 'Order Items',
    shippingAddressOpt: 'Shipping Address (optional)',
    shippingAddressPh2: 'Enter shipping address...',
    specialInstructions: 'Any special instructions...',
    customerLabel: 'Customer',
    // Toast messages
    toastOrderUpdated: 'Order updated!',
    toastOrderUpdateFailed: 'Failed to update order',
    toastOrderDeleted: 'Order deleted!',
    toastOrderDeleteFailed: 'Failed to delete order',
    toastInvoiceDeleted: 'Invoice deleted!',
    toastInvoiceDeleteFailed: 'Failed to delete invoice',
    toastReminderSent: 'Payment reminder sent!',
    toastReviewSent: 'Review request sent!',
    toastQuoteDeleted: 'Quote deleted!',
    toastStatusUpdated: 'Quote status updated!',
    toastInvoiceCreated: 'Invoice created and emailed!',
    toastDelivered: 'Package delivered! Customer notified by email.',
    toastAlreadyDelivered: 'Already marked delivered.',
    toastRefreshFailed: 'Failed to refresh tracking',
    confirmDeleteOrder: 'Delete this order?',
    confirmDeleteInvoice: 'Archive this invoice? It will be hidden from the main view but the signature stays preserved in the Signatures tab. You can restore it later from Signatures → Trash.',
    confirmDeleteQuote: 'Delete this quote?',
  },
};
